import React, { useState, useEffect } from "react";
import "./Body.css";
import { Link, useNavigate } from "react-router-dom";
import testimonials from '../JSON/Testimonial.json'
import AboutUs from "../pages/AboutUs";
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { IconButton } from "@mui/material";
import OurMentors from "../pages/Mentors";
import Testimonials from "../pages/Testimonials";
import Courses from "../pages/Courses";
import ContactSection from "../pages/ContactSection";

const Body = ({ activeSection }) => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const navigate = useNavigate(); // Hook to navigate between routes

  const handleRedirect = () => {
    navigate("/about"); // Change "/target-page" to your desired route
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      name: e.target.elements.name.value,
      email: e.target.elements.email.value,
      mobile: e.target.elements.mobile.value,
      course: e.target.elements.course.value,
      mode: e.target.elements.mode.value,
      message: e.target.elements.message.value,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/feedback`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setFormSubmitted(true);
        e.target.reset(); // Clear the form
        setTimeout(() => setFormSubmitted(false), 3000);
      } else {
        throw new Error("Failed to send message");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to send message. Please try again.");
    }
  };



  const renderSection = () => {
    switch (activeSection) {
      case "home":
        return (
          <div className="home-section">
            <Courses />

            <section id="about" className="about-section">
              <h2>About Us</h2>
              <div className="about-content">
                <p>
                  Curiospark Technologies is a leading IT training and solutions provider, committed to delivering
                  industry-relevant skills through practical, hands-on learning. Beyond traditional courses, we host webinars &
                  seminars led by industry experts, providing professionals with insights into emerging technologies and
                  market trends. Our interactive sessions ensure that learners stay ahead in the ever-evolving digital landscape.
                </p>
                <IconButton onClick={handleRedirect} sx={{ color: "#d4a373", mt: 1 }}>
                  <KeyboardDoubleArrowDownIcon sx={{ fontSize: 50 }} />
                </IconButton>
              </div>
            </section>
            <Testimonials />
          </div>


        );

      case "courses":
        return (
          <Courses />
        );

      case "about":
        return (
          <AboutUs />
        );

      case "mentors":
        return (
          <OurMentors />
        );

      case "testimonials":
        return (
          <Testimonials />
        )

      case "contact":
        return (
          <ContactSection />
        );

      default:
        return null;
    }
  };

  return (
    <main
      className={`main-content ${activeSection !== "home" ? "single-section-view" : ""
        }`}
    >
      {renderSection()}
    </main>
  );
};

export default Body;
